import type { CSSProperties, ReactNode } from "react";
import { spacing } from "../layout/spacing";
import { paymentBrandArtwork } from "./paymentBrandArtwork";

interface BrandIconProps {
  size?: number | string;
  style?: CSSProperties;
}

export function PaymentBrandIcon({ name, size = "1.5em", style }: BrandIconProps & { name: string }) {
  const artwork = paymentBrandArtwork[name];
  return (
    <span
      aria-hidden
      style={{
        display: "inline-block",
        width: "3em",
        height: size,
        flexShrink: 0,
        backgroundColor: "currentColor",
        maskImage: `url("${artwork}")`,
        maskRepeat: "no-repeat",
        maskPosition: "center",
        maskSize: "contain",
        ...style,
      }}
    />
  );
}

export function PayPalBrandIcon(props: BrandIconProps) { return <PaymentBrandIcon name="paypal" {...props} />; }
export function StripeBrandIcon(props: BrandIconProps) { return <PaymentBrandIcon name="stripe" {...props} />; }
export function SepaBrandIcon(props: BrandIconProps) { return <PaymentBrandIcon name="sepa" {...props} />; }
export function VisaBrandIcon(props: BrandIconProps) { return <PaymentBrandIcon name="visa" {...props} />; }
export function MastercardBrandIcon(props: BrandIconProps) { return <PaymentBrandIcon name="mastercard" {...props} />; }

/** Shared logo slot, with no chip or background behind the artwork. */
export function PaymentBrandBadge({ children }: { children: ReactNode }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "4em", gap: spacing.microGap, flexShrink: 0 }}>
      {children}
    </span>
  );
}
